/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Main/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Board from './Board/index'
import React from 'react'
import Settings from './Settings/index'
import Subscribers from './Subscribers/index'
import TasksList from './TasksList/index'



/** @type {import('Simple/types.js').View} */
export default function Main({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Board'
let tabSelectedBoardSubmenuTabIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.board_submenu_tab_id',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: tabSelectedBoardSubmenuTabIdValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Board'}>
<Board
  viewPath={`${viewPath}/Board`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TasksList'}>
<TasksList
  viewPath={`${viewPath}/TasksList`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Subscribers'}>
<Subscribers
  viewPath={`${viewPath}/Subscribers`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Settings'}>
<Settings
  viewPath={`${viewPath}/Settings`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}